import { render, staticRenderFns } from "./DlgMemberEdit.vue?vue&type=template&id=4954a7d6&scoped=true&"
import script from "./DlgMemberEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgMemberEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4954a7d6",
  null
  
)

export default component.exports